import { ButtonIcon, ButtonSize, ButtonVariant, IconVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

import { cn } from "@/utils";

type DiscoverRowArrowProps = {
  isNext: boolean;
  onClick: () => void;
  label: string;
};

const DiscoverRowArrow = ({ isNext, onClick, label }: DiscoverRowArrowProps) => {
  return (
    <ButtonIcon
      data-testid={isNext ? "DiscoverRowTrack-NextButton" : "DiscoverRowTrack-PreviousButton"}
      type="button"
      icon={isNext ? IconVariants.CHEVRON_RIGHT : IconVariants.CHEVRON_LEFT}
      variant={ButtonVariant.TRANSPARENT}
      size={ButtonSize.MEDIUM}
      aria-label={label}
      onClick={onClick}
      className={cn(
        "absolute top-1/2 z-10 -translate-y-1/2 bg-gray-9/70 text-white shadow-md backdrop-blur-sm hover:bg-gray-9/90",
        isNext ? "right-2" : "left-2",
      )}
    />
  );
};

export default React.memo(DiscoverRowArrow);
